import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "coupon-footer"
};
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import CouponDetailInfo from "./CouponDetailInfo.vue";
import CouponDetailDesc from "./CouponDetailDesc.vue";
import { computed } from "vue";
import { useUserStore } from "@/store/userStore";
import { useOrder } from "@/hooks/useOrder";
import { CouponStatusEnum, CouponUseOrderType } from "@/constant/coupon";
import { buyProduct } from "@/api/reward";
import Dialog from "../dialog/dialog";
import { Notify } from "@/utils/notifyUtil";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { watch } from "vue";
import { ref } from "vue";
import { PopupPageKey } from "@/constant/pageKey";
import { getPointProductDetail } from "@/api/reward";
import { useI18n } from "vue-i18n";
export default {
  __name: 'CouponDetailPopup',
  props: {
    coupon: {
      type: [Object, null],
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    }
    // from: {
    //   type: String,
    //   default: "",
    // },
  },
  emits: ["update:show", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useOrder = useOrder(),
      toOrderView = _useOrder.toOrderView;
    var props = __props;
    var userStore = useUserStore();
    var isDisabled = computed(function () {
      if (!isMy.value && !isAllowBuy.value) {
        return true;
      }
      if (!isMy.value && userStore.getPoints < props.coupon.points_price) return true;
      if (isMy.value) {
        return props.coupon.status !== CouponStatusEnum.UNUSED;
      }
      return false;
    });
    var isHidden = computed(function () {
      if (isMy.value) {
        // 已使用、已过期、只有堂食/外带配置时不显示
        var couponInfo = props.coupon.coupon_info;
        return props.coupon.status === CouponStatusEnum.USED || props.coupon.status === CouponStatusEnum.EXPIRED || (couponInfo.order_types.includes(CouponUseOrderType.DINE_IN) || couponInfo.order_types.includes(CouponUseOrderType.TAKEAWAY)) && !couponInfo.order_types.includes(CouponUseOrderType.SELF_DELIVERY) && !couponInfo.order_types.includes(CouponUseOrderType.SELF_PICK_UP);
      }
      return false;
    });
    var isAllowBuy = ref(false); // 是否允许购买的标志位,目前由详情接口获取

    var isMy = computed(function () {
      return props.type === "my";
    });
    var emit = __emit;
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });

    // const fromMapper = {
    //   Rewards: {
    //     routeName: "Rewards",
    //     pageName: "detail",
    //     routePath: "/home/reward",
    //   },
    //   MyCouponList: {
    //     routeName: "MyCouponList",
    //     pageName: "detail",
    //     routePath: "/my_coupon",
    //   },
    // };

    var pagePopupRef = ref();
    watch(showPopup, function () {
      if (showPopup.value) {
        var _pagePopupRef$value;
        (_pagePopupRef$value = pagePopupRef.value) === null || _pagePopupRef$value === void 0 || _pagePopupRef$value.toTop();
        getProductDetail();
      } else {
        isAllowBuy.value = false;
      }
    });
    var getProductDetail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!props.coupon.id || isMy.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              showLoading();
              _context.next = 5;
              return getPointProductDetail({
                id: props.coupon.id
              });
            case 5:
              res = _context.sent;
              hideLoading();
              if (res.isOK && res.data) {
                isAllowBuy.value = res.data.allow_buy;
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getProductDetail() {
        return _ref2.apply(this, arguments);
      };
    }();
    var submit = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!isMy.value) {
                _context3.next = 3;
                break;
              }
              toOrderView();
              // showPopup.value = false;
              return _context3.abrupt("return");
            case 3:
              Dialog.confirm({
                title: t("exchangeGoods"),
                desc: t("areYouSureToExchangeThisGoods"),
                okText: t("yes"),
                onOk: function () {
                  var _onOk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                    var res;
                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          showLoading();
                          _context2.next = 3;
                          return buyProduct({
                            product_id: props.coupon.id
                          });
                        case 3:
                          res = _context2.sent;
                          hideLoading();
                          if (res.isOK) {
                            Notify.success(t("successfulExchange"));
                            // showPopup.value = false;
                            userStore.setPoints(res.data.points_remaining);
                            emit("success");
                          }
                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                  function onOk() {
                    return _onOk.apply(this, arguments);
                  }
                  return onOk;
                }(),
                cancelText: t("no")
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function submit() {
        return _ref3.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createBlock(PagePopupLayout, {
        ref_key: "pagePopupRef",
        ref: pagePopupRef,
        show: showPopup.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return showPopup.value = $event;
        }),
        title: _ctx.$t('voucher'),
        class: "coupon-detail",
        "show-footer": "",
        "page-key": _unref(PopupPageKey).DETAIL
      }, {
        footer: _withCtx(function () {
          return [!isHidden.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Button, {
            type: "content",
            disabled: isDisabled.value,
            class: "coupon-btn-footer",
            onClick: submit
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(isMy.value ? _ctx.$t("useNow") : _unref(userStore).getPoints < props.coupon.points_price ? _ctx.$t("pointsInsufficient") : isAllowBuy.value ? _ctx.$t("redeem") : _ctx.$t("alreadyRedeemed")), 1)];
            }),
            _: 1
          }, 8, ["disabled"])])) : _createCommentVNode("", true)];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_Gap, {
            h: 0.06
          }), __props.coupon ? (_openBlock(), _createBlock(CouponDetailInfo, {
            key: 0,
            coupon: __props.coupon,
            "is-my": isMy.value
          }, null, 8, ["coupon", "is-my"])) : _createCommentVNode("", true), _createVNode(_component_Gap, {
            h: 0.06
          }), __props.coupon ? (_openBlock(), _createBlock(CouponDetailDesc, {
            key: 1,
            coupon: __props.coupon,
            "is-my": isMy.value
          }, null, 8, ["coupon", "is-my"])) : _createCommentVNode("", true), _createVNode(_component_Gap, {
            h: 0.06
          })];
        }),
        _: 1
      }, 8, ["show", "title", "page-key"]);
    };
  }
};